import { AsyncPipe, NgClass, NgIf, NgStyle } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

const DEFAULT_HEIGHT = 300;
const MINIMAL_HEIGHT_DIFFERENCE = 100;

@Component({
  selector: 'sd-spoiler',
  templateUrl: './spoiler.component.html',
  styleUrls: ['./spoiler.component.scss'],
  imports: [NgIf, AsyncPipe, NgClass, NgStyle, I18nModule, IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpoilerComponent implements OnInit, AfterViewInit {
  @ViewChild('contentElement') contentElement: ElementRef;

  @Input() height: number = DEFAULT_HEIGHT;
  @Input() showAllText?: string;
  @Input() collapseText?: string;
  @Input() dataAnalytics?: string;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() toggle = new EventEmitter<boolean>();

  @Input() set opened(opened: boolean) {
    this.opened$.next(opened);
  }

  @Input() set enabled(enabled: boolean) {
    this.enabled$.next(enabled);
  }

  iconType = CUSTOM_ICON_TYPE;

  opened$ = new BehaviorSubject<boolean>(false);
  enabled$ = new BehaviorSubject<boolean>(true);
  displayEnabled$: Observable<boolean>;
  heightInPx$: Observable<string>;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.displayEnabled$ = this.enabled$.pipe(
      map(
        (enabled: boolean) =>
          enabled && (this.contentElement?.nativeElement.scrollHeight || 0) - this.height > MINIMAL_HEIGHT_DIFFERENCE,
      ),
    );
    this.heightInPx$ = combineLatest([this.displayEnabled$, this.opened$]).pipe(
      map(([enabled, opened]: [boolean, boolean]) => {
        if (opened || !enabled) {
          return `${this.contentElement?.nativeElement.scrollHeight || this.height}px`;
        } else {
          return `${this.height}px`;
        }
      }),
    );
  }

  ngAfterViewInit(): void {
    // Только так спойлер корректно обновляется,
    // без этого displayEnabled$ и heightInPx$ не будут пересчитаны,
    // когда contentElement перестанет быть undefined
    this.enabled$.next(this.enabled$.getValue());
    this.cd.detectChanges();
  }

  onToggle(): void {
    const opened = !this.opened$.getValue();
    this.opened$.next(opened);
    this.toggle.emit(opened);
  }
}
